import { useDroppable } from '@dnd-kit/core';
import React from 'react';
import styles from './DragAndDropWrapper.module.scss';

interface IRowDividerDropContainer {
    rowIndex: number;
}

const RowDividerDropContainer: React.FC<IRowDividerDropContainer> = (props: IRowDividerDropContainer) => {
    const { isOver, setNodeRef } = useDroppable({
        id: `row-divider-${props.rowIndex}`,
    });

    return (
        <div ref={setNodeRef} className={styles.dragAndDrop_row_divider}>
            {isOver && <div className={styles.dragAndDrop_row_divider_highlight} />}
        </div>
    );
};

export default RowDividerDropContainer;
